'use client';

import { Component } from '@headless-workspace/typings';
import { UserSessionRepositoryType } from '../../DI/dependencyInjection';
import { CommonDI } from '../../DI/index';
import { useLinksObserver } from './hooks';
import { useUserSession } from './user';

export const LayoutDidMount: Component = () => {
    'use memo';
    useUserSession(CommonDI.get(UserSessionRepositoryType));
    useLinksObserver();

    return null;
};
